@if (src()) {
    <img
        [src]="src()"
        [alt]="alt()"
        part="image"
    />
} @else {
    @if (text() || fio()) {
        {{ text() || fio() }}
    } @else {
        <bazis-icon [icon]="emptyIcon()"></bazis-icon>
    }
}

<ng-content></ng-content>
